import { createGlobalStyle as t } from "styled-components";
import r from "styled-reset";
const i = t([
  "",
  ";html,body,#root{height:100%;width:100%;font-weight:",
  ";box-sizing:border-box;background-color:",
  ";font-family:",
  ";font-size:",
  ";color:",
  ";}*{font-family:",
  ";}"
], r, ({ theme: o }) => o.typography.fontWeightRegular, ({ theme: o }) => o.primaryBackground, ({ theme: o }) => o.typography.fontFamily, ({ theme: o }) => `${o.typography.fontSize}px`, ({ theme: o }) => o.color.text.highemphasis, ({ theme: o }) => o.typography.fontFamily);
export {
  i as default
};
